<template>
  <div>
    <el-form :model="formData" size="small" label-width="80px">
      <el-form-item label="用户" v-if="JSON.stringify(data) === '{}'">
        <el-select
          v-model="userId"
          filterable
          remote
          placeholder="请输入关键词"
          :remote-method="remoteMethod"
          :loading="loading"
          style="width: 220px;"
          @change="handleUserInfoChange">
          <el-option
            v-for="item in userList"
            :key="item.userId"
            :label="`${item.userName}-${item.workNo}`"
            :value="item.userId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户" v-else>
        {{formData.userName + '-' + formData.workNo}}
      </el-form-item>
      <el-form-item label="店铺">
        <el-select v-model="formData.storeCodeList" filterable multiple collapse-tags placeholder="请选择" style="width: 220px;">
          <el-option
            v-for="item in authOptions"
            :key="item.storeCode"
            :label="item.storeName"
            :value="item.storeCode">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from '@/utils/axiosInstance'
export default {
  props: ['data','authOptions'],
  data() {
    return {
      formData: {},
      userId: '',
      userList: [],
      loading: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
    }
  },
  mounted() {
    let formData = JSON.parse(JSON.stringify(this.data));
    formData['storeCodeList'] = formData['storeCode'] && formData['storeCode'].split(',');
    this.formData = formData;
  },
  methods: {
    remoteMethod(query) {
      this.loading = true;
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm))
      currencyForm.reportCode = 'searchUserInfoByName'
      currencyForm.pageSize = 100
      currencyForm.param = {
        userName: query
      }
      axios.post(`/ec-pc-api/custom/reports/data/searchUserInfoByName`,currencyForm).then(res => {
        if(res.code == 200) {
          this.userList = res.data.list
          this.loading = false;
        } 
      })
    },
    handleUserInfoChange(data) {
      const activeObj = this.userList.find(v=>v.userId === this.userId);
      this.formData['userId'] = activeObj.userId;
      this.formData['workNo'] = activeObj.workNo;
      this.formData['userName'] = activeObj.userName;
    },
  }
}
</script>

<style lang="stylus" scoped>
  >>> .el-input--small .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
    width 100% !important
  >>> .el-input
    width 100% !important
</style>